<div class="modal-header">
  <h4 class="modal-title">{{ 'PAYZEN_REFUND_ERROR_TITLE' | translate }}</h4>
  <i aria-label="Close" (click)="handleClick()" class="close pull-right align-middle fas fa-times"> </i>
</div>

<div class="modal-body">
  <p class="text-center">
    {{ 'PAYZEN_REFUND_ERROR_BODY' | translate }}
  </p>
  <p class="alert alert-warning text-center" *ngIf="errorCode || errorMessage">
    <span class="font-weight-500">{{ errorCode }}</span
    >&nbsp;{{ errorMessage }}
  </p>
  <div class="alert alert-info text-left">
    <jhi-bary-icon icon="info-circle" [faDirective]="FAS" size="lg" class="mr-1"></jhi-bary-icon>
    <span>{{ 'ERROR.LINK_ADVICE' | translate }}</span
    >&nbsp;:&nbsp;
    <a href="https://payzen.io/fr-FR/rest/V4.0/api/errors_psp.html" target="_blank">{{ 'LABEL.CLICK_HERE' | translate }}</a>
  </div>
</div>

<div class="modal-footer">
  <jhi-bary-button (clickEvent)="handleClick()" [label]="'BTN.CONTINUE' | translate" color="primary"> </jhi-bary-button>
</div>
